(function () {
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }

  function renderProgress(cart) {
    var el = qs('[data-cdu-progress]');
    if (!el || !cart) return;
    var threshold = parseInt(el.getAttribute('data-cdu-threshold'), 10) || 1;
    var reward = el.getAttribute('data-cdu-reward') || '';
    var textPending = el.getAttribute('data-cdu-text-pending') || 'Add [x] more product(s) and get [reward]';
    var textComplete = el.getAttribute('data-cdu-text-complete') || "You've unlocked [reward]!";
    var qty = cart.item_count || 0;
    var remaining = Math.max(threshold - qty, 0);
    var percent = Math.min((qty / threshold) * 100, 100);

    var textEl = qs('[data-cdu-progress-text]', el);
    var fillEl = qs('[data-cdu-progress-fill]', el);
    if (textEl) {
      textEl.textContent = remaining > 0
        ? textPending.replace('[x]', remaining).replace('[reward]', reward)
        : textComplete.replace('[reward]', reward);
    }
    if (fillEl) fillEl.style.width = percent + '%';
    el.classList.toggle('cdu-progress--complete', remaining === 0);
  }

  function fetchCartAndRenderProgress() {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(renderProgress)
      .catch(function () {});
  }

  // Impulse dispatches 'cart:updated' with the fresh cart object any time it
  // rebuilds the cart drawer (quantity changes, removals, and after we ask it
  // to rebuild via 'cart:build' below). This is the theme's own documented
  // hook (see Impulse > JavaScript events for developers), so we piggyback on
  // it instead of guessing at internals.
  document.addEventListener('cart:updated', function (evt) {
    renderProgress(evt.detail && evt.detail.cart);
  });

  // Items can also be added from a native product-page "Add to cart" form,
  // which does NOT dispatch 'cart:updated' (Impulse only sends 'ajaxProduct:added'
  // in that case, without a full cart payload). Re-fetch /cart.js whenever that
  // fires so the progress bar count stays accurate no matter how an item was added.
  document.addEventListener('ajaxProduct:added', function () {
    fetchCartAndRenderProgress();
  });

  document.addEventListener('DOMContentLoaded', fetchCartAndRenderProgress);

  // Cross-sell "Add" buttons: add the variant via the standard Ajax Cart API,
  // then ask Impulse to rebuild the entire drawer (line items + subtotal)
  // exactly as it would after any native add-to-cart.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cdu-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = '✓';
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(fetchCartAndRenderProgress, 300);
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });
})();
